import axios from 'axios'
import stringify from 'qs-stringify'
import jsonpAdapter from 'axios-jsonp'
import { genSign } from '../utils/util'
import { getStore } from '~/plugins/vuex-store'

import getUrl, { urlMap } from '~/constant/apiUrl'
import { sentryReport } from '~/plugins/init-sentry'

const instance = customRequest()
// nodejs FormData is not defined
// const FormData = process.server ? require('form-data') : window.FormData

export default getServerRequest(instance)

export function getServerRequest(request) {
  return function(urlKey, option = {}, extendsOptions = {}) {
    const store = getStore()
    const { userid, sessionid } = store.state.userInfo
    // 如果没有在apiUrl定义特定名称，就用url做key, 后续有接口服务端渲染需要登录态时处理
    const urlConfig = urlMap[urlKey] || { method: 'get', data: {}, headers: {} }
    const url = getUrl(urlKey)

    option.method = option.method || urlConfig.method || 'get'
    option.body = {
      userid: userid + '',
      user_id: userid + '',
      sessionid,
      ...urlConfig.data,
      // ...(process.server ? { sessionid } : {}),
      ...(option.body || {})
    }
    option.headers = {
      ...urlConfig.headers,
      ...(option.headers || {})
    }
    extendsOptions.showNotify = !!urlConfig.showNotify
    extendsOptions.needLogin = !!urlConfig.needLogin

    const commit = (loading, response = {}, error = false) => {
      store.commit('apiStatus/setApiStatus', {
        key: urlKey,
        value: {
          loading,
          response,
          error,
          isServer: process.server,
          isClient: process.client,
          body: option.body || {}
        }
      })
    }
    commit(true)
    return request(url, option, extendsOptions)
      .then((data) => {
        commit(false, data)
        return data
      })
      .catch((err) => {
        commit(false, err, true)
        return Promise.reject(err)
      })
  }
}

export function jsonp(url, callback = 'callback') {
  return axios({
    url,
    adapter: jsonpAdapter,
    callbackParamName: callback
  })
}

function customErrHandler(err = {}, showNotify = false) {
  if (process.client && err.isAxiosError) {
    const errMsg = err.message || ''
    const isTimeout = errMsg.includes('timeout')
    const isNetError = errMsg.includes('Network Error')
    const message = isTimeout
      ? '接口超时'
      : isNetError
      ? '网络异常'
      : '服务器异常'
    showNotify &&
      $nuxt.$notify({
        title: '接口异常',
        message
      })
  }
  if (process.client) {
    if (err.code === 10017) {
      getStore().commit('clearLogin')
    }
    showNotify &&
      $nuxt.$notify({
        title: '接口异常',
        message: err.message
      })
  }
}
export function customRequest({
  baseURL,
  convertResponse = (res) => [res && res.code === 0, res && res.data],
  timeout = 5000,
  withCredentials = true,
  errHandler = customErrHandler
} = {}) {
  const _instance = axios.create({
    baseURL,
    timeout,
    withCredentials,
    proxy:
      process.env.NODE_ENV === 'development'
        ? {
            host: '10.10.62.18',
            port: 8899
          }
        : false
  })
  _instance.interceptors.request.use(
    function(config) {
      const state = getStore().state
      // Do something before request is sent
      // 线上K8S服务端访问同服务的接口，没走网关导致没有https证书
      if (process.server) {
        if (config.url.includes('.xunlei.com')) {
          if (config.url.includes('http')) {
            config.url = config.url.replace('https://', 'http://')
          } else {
            config.url = 'http:' + config.url
          }
        }
        config.headers.Cookie = state.cookie
        config.headers['User-Agent'] = state.userAgent
      }
      return config
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )
  // convertResponse === false：表示要自定义转换函数
  if (convertResponse) {
    _instance.interceptors.response.use(
      function(response) {
        const res = response.data
        const [flag, data] = convertResponse(res)
        // null表示空值，undefined表示未赋值，析构的时候null会被跳过
        if (flag) return data === null ? undefined : data
        // Do something with response data
        // process.winstonLog.info(response.config)
        return Promise.reject(res)
      },
      function(error) {
        // Do something with response error
        return Promise.reject(error)
      }
    )
  }
  const fn = (url, options, extendOptions = {}) => {
    const [newUrl, newOptions] = getNewOptions(url, options)
    return _instance({
      url: newUrl,
      ...newOptions
    }).catch((err) => {
      if (extendOptions.errHandler) {
        extendOptions.errHandler(err)
      } else {
        errHandler(err, extendOptions.showNotify)
      }
      sentryReport.error(err)
      return Promise.reject(err)
    })
  }
  fn._instance = _instance
  return fn
}

function getNewOptions(url, options = {}) {
  const newOptions = { method: 'get', body: {}, sign: true, ...options }
  if (newOptions.method) {
    newOptions.method = newOptions.method.toUpperCase()
  }
  const isGetDel = ['GET', 'DELETE'].includes(newOptions.method)
  if (isGetDel) {
    newOptions.body._t = Date.now()
  }
  if (newOptions.sign) {
    newOptions.body.sign = genSign(newOptions.body)
    delete newOptions.sign
  }
  if (isGetDel) {
    newOptions.params = newOptions.body
  } else if (['POST', 'PUT'].includes(newOptions.method)) {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    newOptions.headers = {
      Accept: 'application/json',
      // https://github.com/github/fetch/issues/505
      'Content-Type': 'application/json; charset=utf-8',
      ...newOptions.headers
    }
    if (newOptions.headers['Content-Type'].includes('x-www-form-urlencoded')) {
      newOptions.body = stringify(newOptions.body)
    } else if (newOptions.headers['Content-Type'].includes('json')) {
      newOptions.body = JSON.stringify(newOptions.body)
    }
    newOptions.data = newOptions.body
  }

  delete newOptions.body
  return [url, newOptions]
}
